import { render, staticRenderFns } from "./noLive.vue?vue&type=template&id=394a799f&scoped=true&"
import script from "./noLive.vue?vue&type=script&lang=js&"
export * from "./noLive.vue?vue&type=script&lang=js&"
import style0 from "./noLive.vue?vue&type=style&index=0&id=394a799f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "394a799f",
  null
  
)

export default component.exports